import {FormControl} from "react-bootstrap";
import React, {useState} from "react";
import Style from "./Style.module.css";
import {useNavigate} from "react-router-dom";
import * as UserService from "../api/UserService";
import {trySetTimeout} from "../hooks/trySetTiemout";
import {useTranslation} from "react-i18next";

function ForgotPassword() {
    const [email, setEmail] = useState("")
    const [emailSend, setEmailSend] = useState(false)
    const [sendDisabled, setSendDisabled] = useState(false)
    const { t } = useTranslation('translation', { keyPrefix: 'forgotPasswordPage' });
    const nav = useNavigate()


    function ResolveEmail(event) {
        setEmail(event.target.value)
    }

    function sendResetPasswordRequest() {
        setSendDisabled(true)
        if (email.length !== 0) {
            UserService.resetPassword(email, ()=>{showSend()}, (response)=>{
                if (response.status === 429) {
                    window.alert("Too many requests. Retry later")
                }
                window.alert(t('smthWentWrongMessage'))
            })
        }
        trySetTimeout(() => {
            setSendDisabled(false)
        }, 10000)
    }

    function showSend() {
        setEmailSend(true)
    }



    if (emailSend) {
        return (
            <div className={Style.startPageMainContainer}>
                <div className={Style.setupPageBlocks}>
                    <header>{t('successMessage')}</header>
                    <div className={Style.defaultButtonColourAndText}
                         onClick={()=>{nav("/")}}>{t('backToTheMain')}
                    </div>
                </div>
            </div>
        )
    } else {
        return (
            <div className={Style.startPageMainContainer}>
                <div className={Style.setupPageBlocks}>
                    <header>{t('header')}</header>
                    <FormControl
                        placeholder={t('emailPlaceholder')}
                        aria-label="Email"
                        aria-describedby="basic-addon1"
                        value={email}
                        onChange={event => ResolveEmail(event)}
                    />
                    <div className={Style.resetPasswordControls}>
                        <button className={Style.defaultButtonColourAndText}
                             onClick={() => nav("/login")}
                        >{t('cancelButton')}
                        </button>
                        <button className={Style.defaultButtonColourAndText}
                             onClick={sendResetPasswordRequest} disabled={sendDisabled}>{t('sendButton')}
                        </button>
                    </div>

                </div>
            </div>
        )
    }

}

export default ForgotPassword